<template>
  <div class="search-popup-box" @touchmove.prevent v-if="show">
    <div class="search-wrap">
      <div class="box-search">
        <div class="search-btn"></div>
        <input type="text" v-model="str" placeholder="请输入想要查找的内容" @blur.stop="getStr()" v-focus>
      </div>
      <div class="close" @mousedown.stop="close">取消</div>
    </div>
    <!--历史搜索-->
    <div class="hot-search-box historySearch">
      <span>历史搜索</span>
      <span class="right-history-text" v-if="historyStr.length > 0" @click="remove">清空历史搜索</span>
    </div>
    <ul class="hot-tags" v-if="historyStr.length > 0">
      <li v-for="(item, i) in historyStr" :key="i"><router-link :to="{name:'search-goods', params:{str: item}}">{{item}}</router-link></li>
    </ul>
    <div v-else class="no-search">您还没有进行任何搜索哦</div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        show: false,
        str: '',
        // 防止点击事件和blur事件冲突
        flag: true
      }
    },
    computed: {
      ...mapState({
        historyStr: 'historySearch'
      })
    },
    directives: {
      focus: {
        inserted: function (el) {
          el.focus()
        }
      }
    },
    created() {
      this.$store.dispatch('history', [])
    },
    methods: {
      open () {
        this.flag = true;
        this.show = true;
        this.str = '';
      },
      close(event) {
        this.flag = false;
        this.show = false
      },
      remove() {
        localStorage.removeItem('searchWord');
        this.$store.dispatch('clearHistory');
      },
      getStr() {
        if (this.flag && this.str) {
          this.$router.push({
            name: 'search-goods',
            params: {
              str: this.str
            }
          });
          this.str = '';
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .search-popup-box{
    width: 100%;
    max-width: 750px;
    height: 100%;
    position: fixed;
    background: $bg01;
    padding: 0 30px;
    top: 0;
    z-index: 999999;
    box-sizing: border-box;
    .search-wrap{
      width: 100%;
      height: 88px;
      display: flex;
      overflow: hidden;
    }
    .no-search{
      width: 100%;
      height: 100px;
      line-height: 100px;
      font-size: 28px;
      color: $fc09
    }
    .box-search{
      width: 100%;
      height: 68px;
      background: white;
      display: flex;
      border-radius: 34px;
      box-shadow: $box-shadow1;
      margin-top: 10px;
      overflow: hidden;
      .search-btn{
        width: 40px;
        height: 100%;
        background: url("../assets/images/search-icon.png") no-repeat;
        background-position: center center ;
        background-size: 40px 40px ;
        margin-left: 30px;
        margin-right: 24px;
      }
      .clear-input{
        width:40px;
        height: 100%;
        background: url("../assets/images/empty-close-icon.png") no-repeat;
        background-position: center center ;
        background-size: 40px 40px ;
        margin-left: 15px;
        margin-right: 20px;
      }
      input{
        flex: 1;
        height: 100%;
        font-size: 28px;
        color: $fc03
      }
    }
    .close{
      width: 70px;
      height: 100%;
      line-height: 88px;
      text-align: right;
      font-size: 28px;
      color: $fc03;
      margin-left: 30px;
      &:active{
        color: $fc07
      }
    }
    .hot-search-box{
      font-size: 28px;
      line-height: 1;
      color: $fc06;
      margin-top: 30px;
    }
    .historySearch{
      margin-top: 40px;
      display: flex;
      span{
        flex: 1;
      }
      .right-history-text{
        text-align: right;
      }
    }
    .hot-tags{
      display: block;
      li{
        display: inline-block;
        padding: 0 30px;
        height: 60px;
        line-height: 60px;
        border-radius: 30px;
        background: $bg02;
        color: $fc03;
        font-size: 24px;
        margin-right: 20px;
        margin-top: 30px;
        -webkit-touch-callout:none;
        -webkit-user-select:none;
        -khtml-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
        &:active{
          background: $bg03;
          color: white
        }
      }
    }
  }
</style>
